import React, { ReactElement } from 'react';
import styled from 'styled-components';

import Node from 'craft/components/Node';
import { CraftNode, Resolver, ToolboxComponentSections } from 'craft/types';

interface Props {
  children?: ReactElement | ReactElement[];
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

// NOTE: this component exists for backward compatibility, use CheckListGroup instead
export const CheckList: Resolver<Props> = ({ children }: Props) => {
  return <Node is={Container}>{children}</Node>;
};

CheckList.craft = {
  displayName: 'Checklist',
  name: 'CheckList',
  isCanvas: true,
  rules: {
    canMoveIn: (incomingNodes: CraftNode[]) =>
      incomingNodes.every((node) => node.data.name === 'CheckListGroup'),
  },
  defaultProps: {
    title: 'Test Checklist',
  },
};

CheckList.toolbox = {
  schema: {
    [ToolboxComponentSections.Layout]: {
      isVisible: false,
    },
  },
};
